"use strict";
var TypeaheadOptions = (function () {
    function TypeaheadOptions(options) {
        Object.assign(this, options);
    }
    return TypeaheadOptions;
}());
exports.TypeaheadOptions = TypeaheadOptions;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/typeahead/typeahead-options.class.js
 ** module id = 843
 ** module chunks = 0
 **/